import autoComplete from '@tarekraafat/autocomplete.js';

class Ajax {

    constructor(elem) {
        this.elem = elem;
        this.action = this.elem.dataset.post;
        this.target = document.querySelector(this.elem.dataset.target);
        this.params = {};
        this.fields = this.elem.querySelectorAll('input, select, textarea');
        console.log(this.fields);
        this.setupParams();
        this.setupPagination();
        this.setupAutocomplete();
    }

    setupPagination() {
        const ajaxPaginationLinks = document.querySelectorAll('.pagination a');
        if (ajaxPaginationLinks.length === 0) {
            return;
        }
        ajaxPaginationLinks.forEach((link) => {
            link.addEventListener('click', (e) => {
                e.preventDefault();
                const pagelinkHref = new URL(link.href);
                const page = pagelinkHref.searchParams.get('paged');
                if (page) {
                    this.params['paged'] = page
                } else {
                    delete this.params.paged;
                }
                this.request();
            });
        });
    }

    setupParams() {
        this.fields.forEach(
            (field) => {
                field.addEventListener('change', (e) => {
                    delete this.params.paged;
                    delete this.params.q;
                    e.preventDefault();
                    if (field.value == '' || field.value == 'all') {
                        delete this.params[field.getAttribute('name')];
                    } else {
                        this.params[field.getAttribute('name')] = field.value;
                    }
                    this.request();
                });
            }
        );
    }

    setupAutocomplete() {
        const searchFiled = document.querySelector('#autoComplete');
            if (searchFiled) {
                const autoCompleteJS = new autoComplete({ 
                    selector: "#autoComplete",
                    data: {
                        src: async () => {
                          try {
                            const source = await fetch(`${window.urls.home}/wp-json/${searchFiled.dataset['entity']}/v2/${searchFiled.dataset['entity']}`);
                            const data = await source.json();
                            return data;
                          } catch (error) {
                            return error;
                          }
                        },
                        keys: ["title"],
                        cache: true
                    },
                    resultItem: {
                        highlight: true,
                    }
                 });
        }

        let that = this;
        if (searchFiled) {
            searchFiled.addEventListener("selection", function (event) {
                event.target.value = event.detail.selection.value.title;
                that.reset();
                that.params.q = event.detail.selection.value.title;
                that.request();
            });
        }
    }

    reset() {
        this.params = {};
        this.fields.forEach((field) => {
            if(field.tagName == 'SELECT'){
                field.value = '';
            } else {
                if (field.value == '') {
                    field.checked = true;
                } else {
                    field.checked = false;
                }
            }

        });
    }

    setupUri() {
        const uri = new URL(this.elem.dataset.baseurl);
        for (const [key, value] of Object.entries(this.params)) {
            if (value === '' || value === 'all') {
                uri.searchParams.delete(key);
            } else {
                uri.searchParams.set(key, value);
            }
        }
        window.history.pushState({}, '', uri);
    }

    request() {
        const RequestBody = new FormData();
        for (const [key, value] of Object.entries(this.params)) {
            RequestBody.append(key, value);
        }
        fetch(this.action, {
            method: 'POST',
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: RequestBody,
        })
            .then(response => response.text())
            .then((data) => {
                const parser = new DOMParser();
                const html = parser.parseFromString(data, 'text/html');
                this.target.innerHTML = html.body.innerHTML;
                document.querySelectorAll('.page-numbers').forEach((link) => {
                    const href = String(link.href);
                    const replaced = href.replace('#038;', `&`);
                    link.setAttribute('href', replaced);
                });
                document.querySelector('#autoComplete').value = '';
                this.setupPagination();
                this.setupUri();
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }
}

export default Ajax;